import { useCallback } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentUserId } from 'src/app/shared/hooks/session';
import type { ShareAction, ShareChannel } from 'src/app/shared/hooks/share';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

export function useQRCodeShare(): ShareAction {
	const { data } = useStarterDashboardV2PageData();
	const sourceLocation = useQueryParamValue('source_location');
	const currentUserId = useCurrentUserId();

	const getTrackingData = useCallback(
		(_channel: ShareChannel) => ({
			view_context: 'starter_dashboard',
			own_petition: data.petition.user.id === currentUserId,
			context: 'starter_dashboard',
			petition_id: `petition_${data.petition.id}`,
			source_location: sourceLocation,
		}),
		[currentUserId, data.petition.id, data.petition.user.id, sourceLocation],
	);

	// We only use the share action helper to handle the share tracking.
	// The short URL is built by the QR generator in GraphQL.
	return useAvailableShareActions(['qrcode'], {
		trackingEventName: 'share_petition',
		getUrl: (_channel: ShareChannel) => '',
		getTrackingData,
		getContent: (_channel: ShareChannel) => '',
		disableShortLinks: true,
	})[0];
}
